<svelte:options immutable={true} />

<script>import { faCopy, faEllipsisV, faFilter, faRedo, faSearch, faSortAmountDownAlt, faUndo } from '@fortawesome/free-solid-svg-icons';
import { CONTEXT_MENU_EXPLANATION } from '../../../../constants.js';
import { faJSONEditorCollapse, faJSONEditorExpand } from '../../../../img/customFontawesomeIcons.js';
import { isObjectOrArray } from '../../../../utils/typeUtils.js';
import Menu from '../../../controls/Menu.svelte';
import { isKeySelection, isMultiSelection, isValueSelection } from '../../../../logic/selection.js';
export let json;
export let selection;
export let readOnly;
export let showSearch = false;
export let historyState;
export let onExpandAll;
export let onCollapseAll;
export let onUndo;
export let onRedo;
export let onSort;
export let onTransform;
export let onContextMenu;
export let onCopy;
export let onRenderMenu;
function handleToggleSearch() {
    showSearch = !showSearch;
}
$: hasJson = json !== undefined;
$: hasSelection = selection != null;
$: hasSelectionContents =
    hasJson &&
        (isMultiSelection(selection) || isKeySelection(selection) || isValueSelection(selection));
let expandMenuItem;
$: expandMenuItem = {
    type: 'button',
    icon: faJSONEditorExpand,
    title: 'Expand all',
    className: 'jse-expand-all',
    onClick: onExpandAll,
    disabled: !isObjectOrArray(json)
};
let collapseMenuItem;
$: collapseMenuItem = {
    type: 'button',
    icon: faJSONEditorCollapse,
    title: 'Collapse all',
    className: 'jse-collapse-all',
    onClick: onCollapseAll,
    disabled: !isObjectOrArray(json)
};
let searchMenuItem;
$: searchMenuItem = {
    type: 'button',
    icon: faSearch,
    title: 'Search (Ctrl+F)',
    className: 'jse-search',
    onClick: handleToggleSearch,
    disabled: json === undefined
};
let defaultItems;
$: defaultItems = !readOnly
    ? [
        expandMenuItem,
        collapseMenuItem,
        {
            type: 'separator'
        },
        {
            type: 'button',
            icon: faSortAmountDownAlt,
            title: 'Sort',
            className: 'jse-sort',
            onClick: onSort,
            disabled: readOnly || json === undefined
        },
        {
            type: 'button',
            icon: faFilter,
            title: 'Transform contents (filter, sort, project)',
            className: 'jse-transform',
            onClick: onTransform,
            disabled: readOnly || json === undefined
        },
        searchMenuItem,
        {
            type: 'button',
            icon: faEllipsisV,
            title: CONTEXT_MENU_EXPLANATION,
            className: 'jse-contextmenu',
            onClick: onContextMenu
        },
        {
            type: 'separator'
        },
        {
            type: 'button',
            icon: faUndo,
            title: 'Undo (Ctrl+Z)',
            className: 'jse-undo',
            onClick: onUndo,
            disabled: !historyState.canUndo
        },
        {
            type: 'button',
            icon: faRedo,
            title: 'Redo (Ctrl+Shift+Z)',
            className: 'jse-redo',
            onClick: onRedo,
            disabled: !historyState.canRedo
        },
        {
            type: 'space'
        }
    ]
    : [
        expandMenuItem,
        collapseMenuItem,
        {
            type: 'separator'
        },
        {
            type: 'button',
            icon: faCopy,
            title: 'Copy (Ctrl+C)',
            className: 'jse-copy',
            onClick: onCopy,
            disabled: !hasSelectionContents
        },
        {
            type: 'separator'
        },
        searchMenuItem,
        {
            type: 'space'
        }
    ];
$: items = onRenderMenu(defaultItems) || defaultItems;
</script>

<Menu {items} />
